module.exports = __webpack_public_path__ + "img/69.b6cfecb5.png";